<template src='./index.html'></template>
<script>

import { getdata } from './data';
import { save } from '@/api/personnel';

export default {
    name: 'ywlxzt_ywgz_xjgz_jqsz',
    components: {},
    props: {
        jqszdialog: {
            type: Boolean,
            default: false
        },
        formData: {
            type: Array,
            default: []
        },
    },
    watch: {
        formData: function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(function() {
                    if (this.formData && this.formData.length > 0) {
                        this.dealData = this.formData.filter(item => item.interceptType ==="1");
                        let matchItem = [];
                        this.formData.filter(item => item.interceptType ==="2").forEach(item => {
                            let match = {};
                            match.secMode = item.mode;
                            match.secStartValue = item.startValue;
                            match.secEndValue = item.endValue;
                            match.secFormatLength = item.formatLength;
                            match.id = item.id;
                            matchItem.push(match);
                        })
                        this.matchData = matchItem;
                    } else {
                        this.dealData = getdata().dealDataList;
                        this.matchData = getdata().matchDataList;
                    }
                });
            }
        }
    },
    data: function() {
        return {
            dealData: getdata().dealDataList,
            matchData: getdata().matchDataList,
            rangeData: getdata().rangeDataList,
            jqszData: [],
            jqszDesc: "",
            saveClickFlag: false,
        };
    },
    mounted() {
    },
    created() {
    },
    methods: {
        closediag() {
            this.$emit('closediag', false);
        },
        addDeal() {
            this.dealData.push({ id: 'add_deal_' + this.dealData.length });
        },
        deleteDeal(id) {
            this.dealData = this.dealData.filter(item => item.id !== id);
        },
        addMatch() {
            this.matchData.push({ id: 'add_match_' + this.matchData.length });
        },
        deleteMatch(id) {
            this.matchData = this.matchData.filter(item => item.id !== id);
        },
        saveCondition() {
            this.saveClickFlag = true;
            this.jqszData = [];
            this.jqszDesc += "待处理方：";
            // 主表数据
            this.dealData.forEach(item => {
                let saveData = {};
                saveData.type = "2"; // 类型为截取
                saveData.interceptType = "1";
                saveData.mode = item.mode;
                saveData.startValue = item.startValue;
                saveData.endValue = item.endValue;
                saveData.formatLength = item.formatLength;
                this.jqszData.push(saveData);
                this.jqszDesc += this.rangeData.filter(item => item.value === saveData.mode)[0].label + " ";
                if (saveData.mode === "00") {
                  this.jqszDesc += "开始字符[" + saveData.startValue + "]至结束字符[" + saveData.endValue + "]；";
                } else if (saveData.mode === "01") {
                  this.jqszDesc += "开始字符[" + saveData.startValue + "]后" + saveData.formatLength + "个字符；";
                }
            })
            // 次表数据
            this.jqszDesc += "匹配对象：";
            this.matchData.forEach(item => {
                let saveData = {};
                saveData.type = "2"; // 类型为截取
                saveData.interceptType = "2";
                saveData.mode = item.secMode;
                saveData.startValue = item.secStartValue;
                saveData.endValue = item.secEndValue;
                saveData.formatLength = item.secFormatLength;
                this.jqszData.push(saveData);
                this.jqszDesc += this.rangeData.filter(item => item.value === saveData.mode)[0].label + " ";
                if (saveData.mode === "00") {
                  this.jqszDesc += "开始字符[" + saveData.startValue + "]至结束字符[" + saveData.endValue + "]；";
                } else if (saveData.mode === "01") {
                  this.jqszDesc += "开始字符[" + saveData.startValue + "]后" + saveData.formatLength + "个字符；";
                }
            });
            this.$emit('closediag', false);
        },
        dealChange(item) {
            if (item.mode === "00" && item.formatLength) {
                item.formatLength = "0";
            }
            if (item.mode === "01" && item.endValue) {
                item.endValue = "";
            }
        },
        matchChange(item) {
            if (item.secMode === "00" && item.secFormatLength) {
                item.secFormatLength = "0";
            }
            if (item.secMode === "01" && item.secEndValue) {
                item.secEndValue = "";
            }
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
